module.exports = __webpack_public_path__ + "static/img/bg-pt.36803c6b.png";